<template>
  <SysDialog
    v-model="DIALOG_ATIVO_COMPUTED"
    :largura="500"
    titulo="Seleção do Fornecedor do Relatório"
  >
    <div v-if="DIALOG_ATIVO_COMPUTED" class="pb-2">
      <div class="my-2">
        <SysFornecedorPorProdutoAutocomplete
          v-model="exportacao.fornecedor"
          :idsFornecedor="filtros.fornecedores"
          label="Selecione o Fornecedor"
          outlined
          hide-details
        />
      </div>
    </div>

    <template #actions>
      <v-btn
        text
        color="primary"
        @click="salvar"
      >
        Gerar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysFornecedorPorProdutoAutocomplete
  from "@/components/compra/carrinho/dialogs/CotacaoV2AposRelatorio/SysFornecedorPorProdutoAutocomplete.vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import SysBotao from "@/components/utils/botoes/SysBotao.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
export default {
  name: "Index",
  components: {
    SysFilialGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysFornecedorAutocomplete,
    SysBotao,
    SysFornecedorPorProdutoAutocomplete,
    SysDialog
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    pedido: Object,
    produtos_pedido: Array,
  },
  data: () => ({
    exportacao: {
      fornecedor: []
    },
    filtros: {
      compradores: [],
      fornecedores: [],
    },
    fornecedores_unicos: []
  }),

  computed: {
    DIALOG_ATIVO_COMPUTED: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
  },
  watch: {
    DIALOG_ATIVO_COMPUTED() {
      if (this.DIALOG_ATIVO_COMPUTED) {
        this.buscarFiltrosExportacao();
      }
    },
  },
  methods: {
    buscarFiltrosExportacao() {
      api.get(`pedidos-compra/${this.pedido.idpedido}/exportacao/api-pedidos-systock/filtros`)
        .then(resposta => {
          const { filtros } = resposta.data;

          this.exportacao.codigo_filial = filtros.filial || '';
          this.filtros.fornecedores = filtros.fornecedores;
        })
        .catch(logout)
    },
    salvar() {
      this.$emit("cotacaoAposRelatorio", this.exportacao.fornecedor);
    }
  }
}
</script>

<style scoped>

</style>
